<template>
    <div>
        <router-link to="/orders" style="font-size:14px;width:30%;text-decoration: none;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p> 
                <p>Go Back To Sales Order</p>
                
        </router-link>
        <div class="actions">
            <h3 style="font-size:28px;line-height:45px">Pre-Order Campaign List</h3>
           
        </div>
        <div>
            <div class="card-container">
                <a-tabs type="card">
                    <a-tab-pane key="1">
                        <span slot="tab">
                            <span><a-icon type="unordered-list" /></span>
                            All Pre-Orders
                            <a-badge style="float:right;padding-top:9px" :count="displayTotalOrders" show-zero/>
                        </span>
                        <div class="requestActions">
                            <!-- <a-form-model
                                :model="orderform"
                            >
                                <a-form-model-item>
                                    <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                        <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                    </a-input>
                                </a-form-model-item>
                            </a-form-model> -->
                        <!-- <a-button @click="allOrderExportExcel" style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                                Export
                        </a-button> -->
                            <!-- <a-button @click="showAddNewOrderPage" style="height:38px; border-raduis:5px; background: #ffffff" icon="plus">
                                Request for Inventory
                            </a-button> -->

                        </div>
                        <div>
                             <a-table
                            :columns="columns"
                            :data-source="orders"
                            :loading="tableLoading"
                            :pagination="pagination"
                            class="orderTable"
                            >

                                <!-- <template slot="thumb" slot-scope="">
                                    <img src='../../assets/img/biothrax_bottom_260_x_300_removebg_preview.png'/>
                                </template> -->
                                <span slot="action" slot-scope="data">
                                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                                        <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            {{data.statusLabel}}
                                            <a-menu slot="overlay">
                                                <a-menu-item v-show="data.statusLabel ==='Pending' || data.statusLabel ==='Live' || data.statusLabel ==='Completed'">
                                                    <a @click="showViewCampaign(data)">View Campaign?</a>
                                                </a-menu-item>
                                                <a-menu-item v-show="data.statusLabel ==='Live' || data.statusLabel ==='Completed'" >
                                                    <a @click="showViewOrders(data)">View Order?</a>
                                                </a-menu-item>
                                                <a-menu-item v-show="data.statusLabel ==='Live' || data.statusLabel ==='Completed'">
                                                    <a @click="showWayBillsPage(data)">Generate Waybill?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                </span>
                                <template slot="status" slot-scope='data'>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Pending'">
                                        <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#ffb102;"> {{data}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Live'">
                                        <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:rgb(23 140 20);"> {{data}} </p>
                                    </div>
                                

                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="data === `Completed`">
                                        <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#41c4fd;"> {{data}} </p>
                                    </div>
                                </template>

                            </a-table>
                        </div>

                    </a-tab-pane>
                    <a-tab-pane key="2">
                        <span slot="tab">
                            <span><a-icon type="unordered-list" /></span>
                            Pending
                            <a-badge style="float:right;padding-top:9px" :count="displayTotalPendingOrder" show-zero/>
                        </span>
                        <div class="requestActions">
                            <!-- <a-form-model
                                :model="orderform"
                            >
                                <a-form-model-item>
                                    <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                        <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                    </a-input>
                                </a-form-model-item>
                            </a-form-model> -->
                            <!-- <a-button @click="newOrderExportExcel" style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                                    Export
                            </a-button> -->
                        </div>

                        <div>
                            <a-table
                            :columns="columnsStatues"
                            :data-source="tablePendingData"
                            :loading="tableLoading"
                            :pagination="{ pageSize: 5 }"
                            class="orderTable"
                            >
                                <span slot="action" slot-scope="data">
                                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                                        <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            {{data.statusLabel}}
                                            <a-menu slot="overlay">
                                                <a-menu-item v-show="data.statusLabel ==='Pending' || data.statusLabel ==='Live' || data.statusLabel ==='Completed'">
                                                    <a @click="showViewCampaign(data)">View Campaign?</a>
                                                </a-menu-item>
                                                <a-menu-item v-show="data.statusLabel ==='Live' || data.statusLabel ==='Completed'" >
                                                    <a @click="showViewOrders(data)">View Order?</a>
                                                </a-menu-item>
                                                <a-menu-item v-show="data.statusLabel ==='Live' || data.statusLabel ==='Completed'">
                                                    <a @click="showWayBillsPage(data)">Generate Waybill?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                </span>
                                <template slot="status" slot-scope='data'>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Pending'">
                                        <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#ffb102;"> {{data}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Live'">
                                        <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:rgb(23 140 20);"> {{data}} </p>
                                    </div>
                                

                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="data === `Completed`">
                                        <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#41c4fd;"> {{data}} </p>
                                    </div>
                                </template>
                            </a-table>
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="3">
                        <span slot="tab">
                            <span><a-icon type="unordered-list" /></span>
                            Completed
                            <a-badge style="float:right;padding-top:9px" :count="displayTotalCompleted" show-zero/>
                        </span>
                        <div class="requestActions">
                            <!-- <a-form-model
                                :model="orderform"
                            >
                                <a-form-model-item>
                                    <a-input style="width: 274px;height: 35px;border-raduis:5px;" v-model="orderform.searchText" placeholder="quich search order...">
                                        <a-icon slot="prefix" type="search" style="color:rgba(0,0,0,.25)" />
                                    </a-input>
                                </a-form-model-item>
                            </a-form-model> -->
                            <!-- <a-button @click="newOrderExportExcel" style="width:159px; height:38px;margin-right: 10px; border-raduis:5px; background: #418a49; color:#fff;" icon="export">
                                    Export
                            </a-button> -->
                        </div>

                        <div>
                            <a-table
                            :columns="columnsStatues"
                            :data-source="tableCompletedData"
                            :loading="tableLoading"
                            :pagination="{ pageSize: 5 }"
                            class="orderTable"
                            >
                                <span slot="action" slot-scope="data">
                                        <!-- <router-link style="color:#98c14b;" to="/order-details"><a-icon style="font-size:25px;" type="ellipsis" /> </router-link> -->
                                        <!-- <a @click="showMoreDetails(data)" style="color:#98c14b;"><a-icon style="font-size:25px;" type="ellipsis" /> </a> -->
                                        <a-dropdown>
                                            <a style="color:#98c14b;" class="ant-dropdown-link" @click="e => e.preventDefault()">
                                                <a-icon style="font-size:25px;" type="ellipsis" />
                                            </a>
                                            {{data.statusLabel}}
                                            <a-menu slot="overlay">
                                                <a-menu-item v-show="data.statusLabel ==='Pending' || data.statusLabel ==='Live' || data.statusLabel ==='Completed'">
                                                    <a @click="showViewCampaign(data)">View Campaign?</a>
                                                </a-menu-item>
                                                <a-menu-item v-show="data.statusLabel ==='Live' || data.statusLabel ==='Completed'" >
                                                    <a @click="showViewOrders(data)">View Order?</a>
                                                </a-menu-item>
                                                <a-menu-item v-show="data.statusLabel ==='Live' || data.statusLabel ==='Completed'">
                                                    <a @click="showWayBillsPage(data)">Generate Waybill?</a>
                                                </a-menu-item>
                                            </a-menu>
                                        </a-dropdown>
                                </span>
                                <template slot="status" slot-scope='data'>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #fff2d6;width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Pending'">
                                        <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#ffb102;"> {{data}} </p>
                                    </div>
                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: rgb(112 236 110 / 55%);width: 118px;height: 27px;border-radius: 30px" v-if="data === 'Live'">
                                        <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:rgb(23 140 20);"> {{data}} </p>
                                    </div>
                                

                                    <div style="display: flex;padding-top: 4px;justify-content: space-around;background: #d1edfc;width: 118px;height: 27px;border-radius: 30px" v-if="data === `Completed`">
                                        <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
                                        <p style="font-size:12px;color:#41c4fd;"> {{data}} </p>
                                    </div>
                                </template>
                            </a-table>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
// import XLSX from "xlsx";

const columns = [
  {
    title: 'Order ID',
    // width: 150,
    key: 'orderNumber',
    dataIndex: 'orderNumber',
  },
  {
    title: 'Campaign Name',
    // width: 150,
    key: 'campaignName',
    dataIndex: 'campaignName',
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    // width: 150,
  },

  {
    title: 'End Date',
    dataIndex: 'endDate',
    // width: 200,
  },
//   {
//     title: 'Products',
//     dataIndex: 'products',
//      key: 'products',
//     //  width: 150,
//   },
    
  {
    title: 'Status',
    key: 'status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: 'Actions',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  },
];

const columnsStatues = [
  {
    title: 'Order ID',
    // width: 150,
    key: 'orderNumber',
    dataIndex: 'orderNumber',
  },
  {
    title: 'Campaign Name',
    // width: 150,
    key: 'campaignName',
    dataIndex: 'campaignName',
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    // width: 150,
  },

  {
    title: 'End Date',
    dataIndex: 'endDate',
    // width: 200,
  },
//   {
//     title: 'Products',
//     dataIndex: 'products',
//      key: 'products',
//     //  width: 150,
//   },
    
  {
    title: 'Status',
    key: 'status',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: 'Actions',
    key: 'action',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  },
];

    export default {
        name: "Orders",
        data(){
            return{
                orders : [],
                tablePendingData:[],
                tableCompletedData:[],
                tableLoading: false,
                pagination: {
                    pageSize:20
                },
                params:{
                    page: 1,
                    perPage:20,
                    searchBy: {},
                    sortBy: {}
                },
                columnsStatues,
                columns,
                rules:{
                    notes: [
                        { required: true, message: 'Please this field cannot be empty' , trigger: 'change'},
                    ],
                
                }
            }
        },
        methods: {
            ...mapActions(['getPreOrderCampaigns','setOrderInfo','confirmNewOrder','declineNewOrder']),
        showAddNewOrderPage(){
            this.$router.push('/request-product').catch(()=>{});
        },
        showSuccessAlert(message) {
        this.$notification['success']({
            message: message,
        });
        },
        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
         
        showViewCampaign(data){
            this.setOrderInfo(data)
            this.$router.push('/view-campaigns').catch(()=>{});
        },
        
        showViewOrders(data){
            this.setOrderInfo(data)
            this.$router.push('/view-orders').catch(()=>{});
        },
        
        showWayBillsPage(data){
            this.setOrderInfo(data)
            this.$router.push('/waybills').catch(()=>{});
        },
        allPreOderCampaigns(campaigns){
            // console.log("campaigns | ", campaigns)
            this.orders = campaigns.map(campaign =>({
                key:campaign.id,
                orderNumber: `#${campaign.id}`,
                campaignName: campaign.name,
                startDate: moment(campaign.startDate).format("DD-MMM-YYYY"),
                endDate: moment(campaign.endDate).format("DD-MMM-YYYY"),
                products:campaign.campaignProducts.length,
                status: campaign.statusLabel,
                action:campaign
            }))
        },
        pendingCampaigns(campaigns){
            campaigns.forEach(campaign => {
                if(campaign.statusLabel === "Pending"){
                    this.tablePendingData.push({
                        key:campaign.id,
                        orderNumber: `#${campaign.id}`,
                        campaignName: campaign.name,
                        startDate: moment(campaign.startDate).format("DD-MMM-YYYY"),
                        endDate: moment(campaign.endDate).format("DD-MMM-YYYY"),
                        products:campaign.campaignProducts.length,
                        status: campaign.statusLabel,
                        action:campaign
                    })
                }
            })
        },
        
        completedCampaigns(campaigns){
            campaigns.forEach(campaign => {
                if(campaign.statusLabel === "Completed"){
                    this.tableCompletedData.push({
                        key:campaign.id,
                        orderNumber: `#${campaign.id}`,
                        campaignName: campaign.name,
                        startDate: moment(campaign.startDate).format("DD-MMM-YYYY"),
                        endDate: moment(campaign.endDate).format("DD-MMM-YYYY"),
                        products:campaign.campaignProducts.length,
                        status: campaign.statusLabel,
                        action:campaign
                    })
                }
            })
        },
        },
        computed:{
            displayTotalOrders(){
                return this.orders.length
            },
            displayTotalPendingOrder(){
                return this.tablePendingData.length
            },
            displayTotalCompleted(){
                return this.tableCompletedData.length
            },
        },
        created() {
            this.tableLoading = true
            this.getPreOrderCampaigns().then(response => {
                this.tableLoading = false;
                
                if(response.status === 200){
                    this.allPreOderCampaigns(response.data.data);
                    this.pendingCampaigns(response.data.data);
                    this.completedCampaigns(response.data.data)
                }else{
                    // console.log("Error | ", response)
                }
            },
            error => {
                console.log("error | ", error)
            })
        }
    }
</script>

<style scoped>
.requestActions{
    display: flex;
    justify-content:flex-end;
    margin-bottom: 20px;
}

.actions{
    display: flex;
    justify-content:space-between;
}

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;

}

.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}
.card-container >>> .ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.card-container >>> .ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}

.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

button:hover{
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}
.orderTable >>> .ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.orderTable >>> .ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.orderTable >>> .ant-pagination-item-active a {
    color: #fff;
}
.orderTable >>> .ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}
</style>